
import { useNavigate } from "react-router-dom";
import { TableCell,  TableHead,  TableRow, IconButton, TableBody, Pagination, Stack } from "@mui/material";
import { MensajeAlertaDanger } from "../../components";
import { LayoutTabla } from "../../layouts";
import { cambiarEstadoOp } from "../../../services/ops/ops.service";
import { useQueryClient } from "@tanstack/react-query";
import { useOpsStore } from "../../../stores/ops/ops";
import { useValidarRoles } from "../../../hooks";
import { fechaMasLarga } from "../../../helpers/prepararFecha";

import Swal from "sweetalert2";
const paginado = Number(process.env.REACT_APP_PAGINADO);



export const TablaDeOps = ({ data, chagePage=() => {}, page=0, mostrar=false }) => {


    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { permitirXRol } = useValidarRoles();
    const isAdmin = permitirXRol('SUPERADMIN');
    
    const { totalOps } = useOpsStore();


    const handleTrueFalse = async(e, op) => {
        e.stopPropagation();
        const action = op.activo ? 'Archivar' : 'Activar';
        const { value } = await Swal.fire({
            title: `${action} O.P.`,
            text: `¿Está seguro de ${action.toLowerCase()} esta O.P.?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: `Sí, ${action}`
        });
        
        if (!value) return;
        
        const resp = await cambiarEstadoOp(op.id);
        if(resp) { queryClient.invalidateQueries({ queryKey: ['todas-ops'] }) }
    };



    const handleOpcionesOp = (uid) => {
        navigate(`/super/detalles-op/${uid}`);
    }


    return (

        <>
        {(data?.length > 0)
        ?   <LayoutTabla
                paginado={
                <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Pagination count={Math.ceil(totalOps / +paginado)} disabled={Math.ceil(totalOps / +paginado) === 1}
                        variant="outlined" page={page + 1} color="primary" 
                        onChange={ (_, newValor) => chagePage(newValor) } 
                    />
                </Stack>
            }>
                <TableHead >
                    <TableRow>
                        { (isAdmin) && <TableCell sx={{width:'7%'}}>A.</TableCell> }
                        <TableCell sx={{width:'13%'}}>O.P.</TableCell>
                        <TableCell sx={{width:'15%'}}>Compra</TableCell>
                        <TableCell sx={{width:'20%'}}>Entrega</TableCell>
                        <TableCell sx={{width:'20%'}}>Usuario</TableCell>
                        <TableCell sx={{width:'15%'}}>Movil</TableCell>
                        <TableCell sx={{width:'15%'}}>Pago</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {data.map( (ops) => (
                    <TableRow key={ ops.id } onClick={ () => handleOpcionesOp(ops.id) } sx={{cursor:'pointer'}}>
                        {(isAdmin) && 
                        <TableCell>
                        {(ops.activo)
                            ? <IconButton className='boton-estado trru' onClick={(e) => handleTrueFalse(e, ops) } />
                            : <IconButton className='boton-estado fall' onClick={ (e) => handleTrueFalse(e, ops) } />
                        }
                        </TableCell>
                        }
                        <TableCell> { ops.op }</TableCell>
                        <TableCell>{ fechaMasLarga(ops.startOp) }</TableCell>
                        <TableCell>
                            {(ops.fechaEntrega) 
                            ?   fechaMasLarga(ops.fechaEntrega)
                            :   <span style={{ color:'red', fontWeight: '600' }}>No-Dato</span>
                            }
                        </TableCell>
                        <TableCell>{ ops?.quienCompra?.nombre }</TableCell>
                        <TableCell>{ ops?.quienCompra?.movil }</TableCell>
                        <TableCell sx={{color:(ops.pago === 'PENDIENTE') ? 'red' : 'white'}}>
                            { ops.pago }
                        </TableCell>
                    </TableRow>
                    ))
                    }
                </TableBody>

            </LayoutTabla>
        :   (!mostrar)
            ?   <MensajeAlertaDanger titulo='No hay ops disponibles' />
            :   ''
        }
        </>
    )
}
